<template>
    <slot v-bind="props" />
</template>

<script setup>
const props = defineProps({
    instance: {
        type: Object,
        default: null,
    },
    isStandalone: {
        type: Boolean,
        default: false,
    },
});
</script>
